import { SVGProps } from "react";

export const TimeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 17.375C13.8493 17.375 17.375 13.8493 17.375 9.5C17.375 5.15076 13.8493 1.625 9.5 1.625C5.15076 1.625 1.625 5.15076 1.625 9.5C1.625 13.8493 5.15076 17.375 9.5 17.375Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.5 5.25964V9.50003H12.5288" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
